import { Link } from "react-router-dom";
import PostAuthor from "../components/PostAuthor";
import { getPlainText } from "../contexts/UserContext";
const PostItem = ({ post }) => {

  if (!post) return

  const shortDescripation =
    post.description.length > 145
      ? post.description.substr(0, 145) + "..."
      : post.description;
  const shortTitle =
    post.title.length > 30
      ? post.title.substr(0, 30) + "..."
      : post.title;

      

  

  return (
    <article className="post">
      {
        post?.postImg && (<div className="post__thumbnail">
        <img src={post?.postImg?.secure_url} alt="" />
      </div>)
      }
      <div className="post__content">
        <Link to={`/posts/${post._id}`}>
          <h3>{shortTitle}</h3>
        </Link>
        <p>{getPlainText(shortDescripation)}</p>
        <div className="post__footer">
          <PostAuthor userId={post?.postedBy} />
          <Link
            className="btn category"
            to={`/posts/categories/${post?.category}`}
          >
            {post.category}
          </Link>
        </div>
      </div>
    </article>
  );
};

export default PostItem;
